import Api from '@/api'

const weigType = {
  data() {
    return {

    }
  },
  methods: {
    wgTypeGo(type) {
      if (type === 1 && this.currTab && this.currTab.relativeId) {
        this.translateActive(this.currTab.relativeId, true, undefined, true)
      }
    },
    addWGTypePre(target) {
      if (target && target.id === '700-b-1' && this.isAggregation) {
        this.$message.warning('复合区子区域无法添加违规类型，请在复合区添加！')
        return
      }
      this.onShowDialogFromTableBtn(null, target)
    },
    addWGType() {
      console.log('addWGType', this.$refs)
      const vm = this
      const pid = this.miTableBtn.id
      const data = {}
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          const ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && ikey === 'area') {
            if (Number(value.radio) === 1) {
              data.radio = value.radio
            } else if (Number(value.radio) === 2) {
              data.radio = value.radio
              if (!value[ikey] || !value[ikey].provience) {
                return this.$message.error('请选择适用范围: 省市区县')
              } else if (!value[ikey] || !value[ikey].city) {
                return this.$message.error('请选择适用范围: 市区县')
              } else if (!value[ikey] || !value[ikey].area) {
                return this.$message.error('请选择适用范围: 区县')
              } else {
                data.provinceId = value[ikey].provience
                data.cityId = value[ikey].city
                data.regionId = value[ikey].area
              }
            }
          } else if (value && (value[ikey] || value[ikey] === 0) && ikey !== 'area') {
            data[ikey] = value[ikey]
          } else {
            return this.$message.error('请填写' + name.replace(':', '').replace('：', ''))
          }
        }
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiPost(data, params, vm.miTableBtn.api)
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('违规类型添加成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('addWGType', err)
        })
    },
    handleDialogFromChange(cp) {
      console.log(11, cp)
    },
    editWGType() {
      console.log('editWGType', this.$refs)
      const vm = this
      const pid = this.miTableBtn.id
      const data = {}
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          const ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && ikey === 'area') {
            if (Number(value.radio) === 1) {
              data.radio = value.radio
            } else if (Number(value.radio) === 2) {
              data.radio = value.radio
              if (!value[ikey] || !value[ikey].provience) {
                return this.$message.error('请选择适用范围: 省市区县')
              } else if (!value[ikey] || !value[ikey].city) {
                return this.$message.error('请选择适用范围: 市区县')
              } else if (!value[ikey] || !value[ikey].area) {
                return this.$message.error('请选择适用范围: 区县')
              } else {
                data.provinceId = value[ikey].provience
                data.cityId = value[ikey].city
                data.regionId = value[ikey].area
              }
            }
          } else if (value && (value[ikey] || value[ikey] === 0) && ikey !== 'area') {
            data[ikey] = value[ikey]
          } else {
            return this.$message.error('请填写' + name.replace(':', '').replace('：', ''))
          }
        }
      }
      data.id = vm.rowData.id
      data.provinceId = vm.rowData.provinceId
      data.cityId = vm.rowData.cityId
      data.regionId = vm.rowData.regionId
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiPost(data, params, vm.miTableBtn.api)
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('违规类型保存成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('editWGType', err)
        })
    },
    delWGType() {
      const vm = this
      const data = {
        id: vm.rowData.id
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiPost(data, params, '/api/miApp/deleteReplyType')
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('违规类型删除成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('delWGType', err)
        })
    }
  }
}

export default weigType
